import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function FileIcon(props) {
	return (
		<Svg
			width={props.size}
			height={props.size}
			viewBox='0 0 12 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<Path
				d='M3.54375 12.3125H8.45625C8.61875 12.3125 8.75313 12.2594 8.85938 12.1531C8.96562 12.0469 9.01875 11.9125 9.01875 11.75C9.01875 11.5875 8.96562 11.4531 8.85938 11.3469C8.75313 11.2406 8.61875 11.1875 8.45625 11.1875H3.54375C3.38125 11.1875 3.24688 11.2406 3.14062 11.3469C3.03437 11.4531 2.98125 11.5875 2.98125 11.75C2.98125 11.9125 3.03437 12.0469 3.14062 12.1531C3.24688 12.2594 3.38125 12.3125 3.54375 12.3125ZM3.54375 9.125H8.45625C8.61875 9.125 8.75313 9.07188 8.85938 8.96563C8.96562 8.85938 9.01875 8.725 9.01875 8.5625C9.01875 8.4 8.96562 8.26562 8.85938 8.15937C8.75313 8.05312 8.61875 8 8.45625 8H3.54375C3.38125 8 3.24688 8.05312 3.14062 8.15937C3.03437 8.26562 2.98125 8.4 2.98125 8.5625C2.98125 8.725 3.03437 8.85938 3.14062 8.96563C3.24688 9.07188 3.38125 9.125 3.54375 9.125ZM1.125 15.5C0.825 15.5 0.5625 15.3875 0.3375 15.1625C0.1125 14.9375 0 14.675 0 14.375V1.625C0 1.325 0.1125 1.0625 0.3375 0.8375C0.5625 0.6125 0.825 0.5 1.125 0.5H7.425C7.575 0.5 7.72188 0.53125 7.86563 0.59375C8.00938 0.65625 8.13125 0.7375 8.23125 0.8375L11.6625 4.26875C11.7625 4.36875 11.8438 4.49062 11.9062 4.63437C11.9688 4.77812 12 4.925 12 5.075V14.375C12 14.675 11.8875 14.9375 11.6625 15.1625C11.4375 15.3875 11.175 15.5 10.875 15.5H1.125ZM7.33125 4.55V1.625H1.125V14.375H10.875V5.1125H7.89375C7.73125 5.1125 7.59688 5.05937 7.49063 4.95312C7.38438 4.84688 7.33125 4.7125 7.33125 4.55ZM1.125 1.625V5.1125V1.625V14.375V1.625Z'
				fill={props.color || "#1D2939"}
			/>
		</Svg>
	);
}

export default FileIcon;
